var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.712708,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5416 17.571C27.3583 16.8827 28.6766 16.8827 29.4699 17.571L31.3133 19.146C31.6633 19.4377 32.3283 19.6827 32.7949 19.6827H34.7783C36.0149 19.6827 37.0299 20.6977 37.0299 21.9344V23.9177C37.0299 24.3844 37.2749 25.0377 37.5666 25.3877L39.1416 27.231C39.8299 28.0477 39.8299 29.366 39.1416 30.1594L37.5666 32.0027C37.2749 32.3527 37.0299 33.006 37.0299 33.4727V35.456C37.0299 36.6927 36.0149 37.7077 34.7783 37.7077H32.7949C32.3283 37.7077 31.6749 37.9527 31.3249 38.2444L29.4816 39.8194C28.6649 40.5077 27.3466 40.5077 26.5533 39.8194L24.7099 38.2444C24.3599 37.9527 23.6949 37.7077 23.2399 37.7077H21.1983C19.9616 37.7077 18.9466 36.6927 18.9466 35.456V33.461C18.9466 33.006 18.7133 32.341 18.4216 32.0027L16.8466 30.1477C16.1699 29.3427 16.1699 28.036 16.8466 27.231L18.4216 25.376C18.7133 25.026 18.9466 24.3727 18.9466 23.9177V21.946C18.9466 20.7094 19.9616 19.6944 21.1983 19.6944H23.2166C23.6833 19.6944 24.3366 19.4494 24.6866 19.1577L26.5416 17.571Z",
    stroke: "#DB6704",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24.1977V29.8327",
    stroke: "#DB6704",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9937 33.3794H28.0041",
    stroke: "#DB6704",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon2);
export default __webpack_public_path__ + "static/media/feature-icon2.1a46c9c5941886bfeae770925a613973.svg";
export { ForwardRef as ReactComponent };